import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { ControlLabelProps } from "../types";

export default function ControlLabel(props: Readonly<ControlLabelProps>) {
  const {
    size = "md",
    error,
    className,
    children,
    required = false,
    ...rest
  } = props;

  return (
    <label
      {...rest}
      className={twMerge(
        clsx("transition-colors min-h-5", {
          "text-xs": size === "sm",
          "text-sm": size === "md",
          "text-base": size === "lg",
          "text-gunmetal-500": !error,
          "text-red-500": error,
        }),
        className,
      )}
    >
      {children}
      {required && <span> *</span>}
    </label>
  );
}
